import React from "react";
import { AHText, AHTextFonts } from "arkh";
import { useIntlTokens } from "../../../components/mobile/useIntlTokens";

export const ListItemEditIcon = () => {
  const intl_tokens = useIntlTokens();

  return (
    <AHText type="title-small" font={AHTextFonts.REGULAR} color="primary">
      {intl_tokens.Edit}
    </AHText>
  );
};
